import Swiper from 'swiper';
import { xl, xl2 } from '../common';

export function initAllArticleSearchBlocks() {
  const blocks = document.querySelectorAll('.js-articles-search');
  blocks.forEach((block) => initArticlesSearch(block));
}

export function initArticlesSearch(parent) {
  if (!parent) return;

  const swiperEl = parent.querySelector('.articles-search__selects-swiper');
  if (swiperEl) {
    new Swiper(swiperEl, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      touchMoveStopPropagation: true,
      spaceBetween: 16,
      breakpoints: {
        [xl]: {
          spaceBetween: 20,
        },
        [xl2]: {
          spaceBetween: 24,
        },
      },
    });
  }
  attachSelectHandlers(parent);
}

function attachSelectHandlers(/** @type {?HTMLFormElement} */ formElement) {
  const updateHandler = function (/** @type {InputEvent} */ _event) {
    try {
      formElement.submit();
    } catch (e) {
      console.error(e);
    }
  };

  formElement.querySelectorAll('select')
    .forEach(function (/** @type {?HTMLSelectElement} */ selectElement) {
      console.log('Attaching update handler', selectElement);
      selectElement.addEventListener('change', updateHandler);
    });
}
